jQuery(document).ready(function ($) {
    "use strict";

    if ( $('.main-header').length ) {
        $('body').css({'paddingTop': $('.main-header').outerHeight()});
    }

    $('.mobile-menu__item.menu-item-has-children').on('click', function (e) {
        $(this).toggleClass('mobile-menu__item--active');
        $(this).siblings().removeClass('mobile-menu__item--active');
    });
});

function headerHeight() {

    if ( jQuery('.main-header').length ) {
        jQuery('body').css({'paddingTop': jQuery('.main-header').outerHeight()});
    }
}

jQuery(window).on('load', headerHeight);
jQuery(window).resize(headerHeight);
